//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import ContainerRowSpace from '../../components/common/ContainerRowSpace'
import ContainerRowTitle from '../../components/common/ContainerRowTitle'
import ContainerRowError from '../../components/common/ContainerRowError'
import InstructionAndDocLink from './InstructionAndDocLink'
import InvoiceHeaderContainer from './InvoiceHeaderContainer'
import InvoiceLineItemsContainer from './InvoiceLineItemsContainer'

const InvoiceDataExtractionForm = props => {
    const { demeter,location } = props;
    const { openAddInvItem } = demeter;
    const query = queryString.parse(location.search);
    
    if (!query.jwt || !query.docUrl || !query.taskAcceptedInfoId || !query.compIdCode ) {
        return (
            <div className="container">
               <ContainerRowSpace />
               <ContainerRowTitle title={'Invoice Data Extraction'} />
               <ContainerRowError errorMsg={'Missing Parameters!'} /> 
            </div>
        )
    }
    
    return (
        <div className="container">
            <ContainerRowSpace />
            <ContainerRowTitle title={'Invoice Data Extraction'} />
            <InstructionAndDocLink docLink={query.docUrl} />
            <InvoiceHeaderContainer query={query}/>
            <InvoiceLineItemsContainer
                isTriggerAddLineItem={openAddInvItem}
                jwt={query.jwt}
                taskAcceptedInfoId={query.taskAcceptedInfoId}
            />
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        demeter: state.demeter
    }
}

export default connect(mapStateToProps)(InvoiceDataExtractionForm);


// WEBPACK FOOTER //
// ./src/views/ProjectDemeter/InvoiceDataExtractionForm.js